var React = require('react');

function ChevronrightInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_14:13342)","key":0},React.createElement("path",{"d":"M5.22813 0.190651L4.60938 0.809401C4.4625 0.956275 4.4625 1.19378 4.60938 1.34065L10.2563 7.00002L4.60938 12.6594C4.4625 12.8063 4.4625 13.0438 4.60938 13.1906L5.22813 13.8094C5.375 13.9563 5.6125 13.9563 5.75938 13.8094L12.3031 7.26565C12.45 7.11877 12.45 6.88127 12.3031 6.7344L5.75938 0.190651C5.6125 0.0437755 5.375 0.0437755 5.22813 0.190651Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_14:13342"},React.createElement("rect",{"width":"14","height":"16","fill":"white","transform":"translate(0 14) rotate(-90)"})))]);
}

ChevronrightInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = ChevronrightInline;

ChevronrightInline.default = ChevronrightInline;
